import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

import {IonList, MenuController, ModalController, Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {Router} from '@angular/router';
import {AuthService} from './services/auth/auth.service';
import {SelectPackagePage} from './pages/package/select-package/select-package.page';
import {Storage} from '@ionic/storage';
import {ResourceService} from './services/resource/resource.service';
import {AppPermission} from './models/comons/enums/AppPermission';
import {Location} from '@angular/common';
import {Plugins} from '@capacitor/core';
import {AlertService} from './services/alert/alert.service';
import {CustomLoaderObjEnum, CustomLoaderObjOption, LoadingService} from './services/loading-spinner/loading.service';
import {ThemeSwitcherService} from './services/theme-switch/theme-switcher.service';
import {SwPush, SwUpdate} from '@angular/service-worker';
import {FcmSetupService} from './services/fcmService/fcm-setup.service';
import {PackageService} from './services/package-service/package.service';

const {Network} = Plugins;

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private router: Router,
        public auth: AuthService,
        private menuController: MenuController,
        private modalController: ModalController,
        private storage: Storage,
        public resourceService: ResourceService,
        private location: Location,
        private alertService: AlertService,
        public loadingService: LoadingService,
        private cd: ChangeDetectorRef,
        private themeSwitcherService: ThemeSwitcherService,
        private updates: SwUpdate,
        private push: SwPush,
        private fcmSetupService: FcmSetupService,
        private packageService: PackageService,
    ) {
        this.initializeApp();
    }

    @ViewChild('themeToggle', {static: true}) private themeToggleElement: HTMLIonToggleElement;
    @ViewChild('submenuQuizCreatorList', {static: false}) private submenuQuizCreatorListEl: ElementRef;

    menuSelectItem = 1;
    modal: any;
    isMobile: boolean = false;
    timestamp: number;
    appIsOnline = true;
    customLoaderObj: CustomLoaderObjOption;
    showCustomLoader: boolean = false;
    submenuQuizCreator: boolean = false;
    submenuActivatePackage: boolean = false;
    currentPackage = null;

    userPackages;


    closeMenu() {
        this.menuController.close('system-menu').then();
    }

    async checkOnlineAndOffline() {
        const status = await Network.getStatus();
        this.appIsOnline = status.connected;

        Network.addListener('networkStatusChange', (status) => {
            this.appIsOnline = status.connected;
        });
    }

    themeChange(event) {
        document.body.classList.toggle('dark', event.detail.checked);
        if (event.detail.checked) {
            this.themeSwitcherService.setTheme(ThemeSwitcherService.package_dark_template, 'package_dark_template');
        } else {
            this.themeSwitcherService.setTheme(this.themeSwitcherService.getBaseColorTheme(this.auth.currentPackageInfo.theme), this.auth.currentPackageInfo.theme);
        }
    }

    toggleTheme() {
        this.themeSwitcherService.getStoredThemeName().then(themeName => {
            if (themeName === 'package_dark_template') {
                this.themeToggleElement.checked = false;
                document.body.classList.toggle('dark', false);
                this.themeSwitcherService.setTheme(this.themeSwitcherService.getBaseColorTheme(this.auth.currentPackageInfo.theme), this.auth.currentPackageInfo.theme);
            } else {
                document.body.classList.toggle('dark', true);
                this.themeToggleElement.checked = true;
                this.themeSwitcherService.setTheme(ThemeSwitcherService.package_dark_template, 'package_dark_template');
            }
        });
    }

    checkToggle = (shouldCheck) => {
        this.themeToggleElement.checked = shouldCheck;
    };

    initializeApp() {
        this.platform.ready().then(() => {

            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
            prefersDark.addListener((e) => this.checkToggle(e.matches));
            this.checkToggle(prefersDark.matches);

            this.themeSwitcherService.getStoredThemeName().then(value => {
                if (value === 'package_dark_template') {
                    this.themeToggleElement.checked = true;
                }
            });

            this.loadingService.showCustomLoader.subscribe(value => {
                this.showCustomLoader = value;
            });
            this.loadingService.customLoaderObj.subscribe(value => {
                this.customLoaderObj = value;
            });

            this.checkOnlineAndOffline().then();
            this.statusBar.styleDefault();

            // this.splashScreen.hide();

            this.auth.refreshInfo.subscribe(value => {
                this.timestamp = value;
            });

            this.isMobile = this.platform.is('cordova') ||
                this.platform.is('mobile') || this.platform.is('mobileweb');

            this.fcmSetupService.listenForMessageFcm();

            this.platform.ready().then(() => {
                this.auth.isAuthentication().then(status => {
                    if (status) {
                        this.checkCurrentPackage();
                    }
                });
            });

        });
        this.auth.currentPackageSubject.subscribe(value => {
            this.currentPackage = value;
        })

    }


    setupFCM() {
        this.push.messages.subscribe(msg => console.log('push message', msg));
        this.push.notificationClicks.subscribe(click => console.log('notification click', click));
    }


    getImageProfile() {
        return this.resourceService.getProfileAvatar(this.auth.user?.username) + '?X_TOKEN=' + this.auth.token;
    }


    hasPermission(permission: string): boolean {
        let appPermission: AppPermission;
        switch (permission) {
            case 'StaticQuiz':
                appPermission = AppPermission.StaticQuiz;
                break;
            case  'TopicQuiz':
                appPermission = AppPermission.TopicQuiz;
                break;
            case 'CustomQuiz':
                appPermission = AppPermission.CustomQuiz;
                break;
        }
        return this.currentPackage?.permissions?.includes(appPermission);
    }

    checkCurrentPackage() {
        this.packageService.getUserAllPackage().toPromise().then(response => {
            if (response.status) {
                if (response.data?.length >= 0) {
                    this.userPackages = response.data;
                    this.storage?.get('current-package').then(cp => {
                        console.log(cp);
                        if (!cp) {
                            this.presentModal().then();
                        }
                    });
                }
            }
        });
    }


    changePackage(pkg: any) {
        if (pkg) {
            this.loadingService.customPresent({
                type: CustomLoaderObjEnum.Image,
                url: '/assets/loader-transition/question.png'
            }).then();
            this.packageService.getUserPackageById(pkg.id).subscribe(result => {
                if (result.status && result.data) {
                    this.storage.ready().then(() => {
                        this.storage.remove('current-package').then((success) => {
                            this.storage.set('current-package', JSON.stringify(result.data))
                                .then(() => {
                                    this.auth.currentPackageInfo = result.data;
                                    this.auth.currentPackageSubject.next(this.auth.currentPackageInfo);
                                });
                        }, reason => console.log(reason));
                    });
                } else {
                    this.alertService.alert('این آزمون برای شما یافت نشد', 'خطا').then();
                }
                this.loadingService.dismissCustom().then();
            }, error => {
                this.loadingService.dismissCustom().then();
            });
        } else {
            this.alertService.alert('بسته مورد نظر را انتخاب کنید', 'انتخاب بسته').then();
        }
    }

    async presentModal() {
        this.modal = await this.modalController?.create({
            component: SelectPackagePage,
            swipeToClose: false,
            backdropDismiss: false,
            componentProps: {}
        });
        this.modal?.onDidDismiss().then((result) => {

        });

        return await this.modal?.present();
    }


    ngOnInit() {
        this.location.onUrlChange(url => {
            // this.trackingUrl(url);
            console.log(url);
        });


    }

    trackingUrl(url: string) {
        switch (url) {
            case '/package/activate-package':
                this.menuSelectItem = 0;
                break;
            case '/dashboard':
                this.menuSelectItem = 1;
                break;
            case '/package/static-quiz':
                this.menuSelectItem = 2;
                break;
            case '/package/custom-topic':
                this.menuSelectItem = 3;
                break;
            case '/package/custom-quiz':
                this.menuSelectItem = 4;
                break;
            case '/package/histories':
                this.menuSelectItem = 5;
                break;
            case '/report':
                this.menuSelectItem = 6;
                break;
            case '/profile':
                this.menuSelectItem = 8;
                break;
            case '/package/my-quiz':
                this.menuSelectItem = 9;
                break;
        }
    }

    menuItemClick(index: number) {
        switch (index) {
            case 0:
                this.menuSelectItem = 0;
                this.router.navigate(['/package/activate-package']).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 1:
                this.menuSelectItem = 1;
                this.router.navigate(['/dashboard']).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 2:
                this.menuSelectItem = 2;
                this.router.navigate(['/package/static-quiz']).then().catch(reason => console.error(reason));
                this.menuController.close().then();
                break;
            case 3:
                this.router.navigate(['/package/custom-topic'], {}).then().catch(reason => console.error(reason));
                this.menuSelectItem = 3;
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 4:
                this.menuSelectItem = 4;
                this.router.navigate(['/package/custom-quiz'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 5:
                this.menuSelectItem = 5;
                this.router.navigate(['/package/histories'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 6:
                this.menuSelectItem = 6;
                this.router.navigate(['/report'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;

            case 7:
                this.alertService.confirmOkButton = () => {
                    this.auth.logout().then().catch(reason => console.error(reason));
                    this.menuController.close().then().catch(reason => console.error(reason));
                };
                this.alertService.cancelButtonCallBack = () => {
                };

                this.alertService.confirm('آیا می خواهید از برنامه خارج شوید؟', 'خروج').then();
                this.menuSelectItem = 7;

                break;
            case 8:
                this.menuSelectItem = 8;
                this.router.navigate(['/profile'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then();
                break;
            case 9:
                this.menuSelectItem = 9;
                this.router.navigate(['/package/my-quiz'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;
            case 10:
                this.menuSelectItem = 10;
                this.router.navigate(['/help'], {}).then().catch(reason => console.error(reason));
                this.menuController.close().then().catch(reason => console.error(reason));
                break;

            case 11:
                this.menuSelectItem = 11;
                this.submenuQuizCreator = !this.submenuQuizCreator;
                break;
            case 12:
                this.menuSelectItem = 12;
                this.submenuActivatePackage = !this.submenuActivatePackage;
                break;
        }
    }
}
